// HeaderNav — лого + горизонтальные вкладки разделов в хедере (сайдбар
// упразднён). Маршруты и активность те же, что были у сайдбара: Discover
// остаётся активным на /pair/* и /tokens/*. Стиль Soft (2026-10-08): лого Gust +
// словесный знак; вкладки без подложки и пилюли — активная белая, её иконка
// акцентная; иконки Phosphor bold.

import { BriefcaseIcon, CompassIcon, GiftIcon } from '@phosphor-icons/react'
import type { ComponentType } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { figs } from '../ui/fig'
import { GustMark } from '../ui/icons/GustMark'
import { HelmetIcon } from '../ui/icons/HelmetIcon'
import styles from './AppHeader.module.css'

interface NavSpec {
  label: string
  to?: string
  match?: (path: string) => boolean
  Icon: ComponentType<{ size?: number; weight?: 'bold' }>
}

const ITEMS: NavSpec[] = [
  {
    label: 'Discover',
    to: '/discover',
    match: (p) => p.startsWith('/discover') || p.startsWith('/pair') || p.startsWith('/tokens'),
    Icon: CompassIcon,
  },
  {
    // Trenches — переименовано из Pulse (фидбек, gmgn-манера); роут прежний
    label: 'Trenches',
    to: '/pulse',
    match: (p) => p.startsWith('/pulse'),
    // a military helmet (operator, 2026-11-02), the Trenches title's own
    Icon: HelmetIcon,
  },
  {
    label: 'Portfolio',
    to: '/portfolio',
    match: (p) => p.startsWith('/portfolio'),
    Icon: BriefcaseIcon,
  },
  { label: 'Rewards', to: '/rewards', match: (p) => p.startsWith('/rewards'), Icon: GiftIcon },
]

export function HeaderNav() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  return (
    <>
      {/* знак Gust + словесный знак; клик → Discover */}
      <button
        type="button"
        className={styles.logoBtn}
        onClick={() => navigate('/discover')}
        aria-label="wils.trade — Discover"
      >
        <GustMark height={24} />
        <span className={styles.wordmark} aria-hidden="true">
          wils.trade
        </span>
      </button>
      <nav className={styles.hdrTabs} aria-label="Sections">
        {ITEMS.map((item) => {
          const active = item.match ? item.match(pathname) : false
          const glyph = <item.Icon size={18} weight="bold" />
          if (!item.to) {
            return (
              <span key={item.label} className={styles.hdrTab} aria-disabled="true" data-inert>
                {glyph}
                {figs(item.label)}
              </span>
            )
          }
          const to = item.to
          return (
            <button
              key={item.label}
              type="button"
              className={styles.hdrTab}
              data-on={active}
              aria-current={active ? 'page' : undefined}
              onClick={() => navigate(to)}
            >
              {glyph}
              {figs(item.label)}
            </button>
          )
        })}
      </nav>
    </>
  )
}
